import moment from 'moment-timezone';

export function convertTimezones(countries: any) {
  const results: any[] = [];

  Object.keys(countries).forEach((code) => {
    const country = countries[code];
    const timezones = country.timezones;

    Object.keys(timezones).forEach((tz) => {
      const timezone = timezones[tz];

      const currentOffset = moment.tz(tz).utcOffset();
      const gmtOffset = currentOffset / 60;
      const sign = gmtOffset >= 0 ? '+' : '-';
      const gmtString = `GMT${sign}${Math.abs(gmtOffset)}`;
      results.push({ value: tz, label: `${timezone.name} (${gmtString})` });
    });
  });

  return results;
}

export function getGMTOffset(timezone: string): string {
  const now = new Date();
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone,
    timeZoneName: 'shortOffset',
  });

  const parts = formatter.formatToParts(now);
  const gmtPart = parts.find((part) => part.type === 'timeZoneName');

  return gmtPart ? gmtPart.value.replace('GMT', '') : '+0';
}

export function convertTimezonesWithGMT(
  timezoneObj: Record<string, any>,
): { label: string; value: string }[] {
  const tzList: string[] = [];

  Object.values(timezoneObj).forEach((country) => {
    if (country.timezones) {
      Object.keys(country.timezones).forEach((tzName) => tzList.push(tzName));
    }
  });

  return tzList.map((tz) => ({
    label: `${tz} (GMT${getGMTOffset(tz)})`,
    value: tz,
  }));
}

export function convertDateToTimezone(
  date: Date | string | null | undefined,
  timezone: string | null | undefined, // pass it here
  format: string = 'DD/MM/YYYY HH:mm:ss',
): string {
  if (!date) return '-';

  const momentDate = moment(date);
  if (!momentDate.isValid()) {
    console.error('Invalid date:', date);
    return '-';
  }

  // Strip any "(GMT...)" from the provided timezone
  let selectedTimezone = timezone?.replace(/\s*\(.*\)$/, '') || 'UTC';

  if (!moment.tz.zone(selectedTimezone)) {
    console.warn(`Timezone "${selectedTimezone}" not found, falling back to UTC`);
    selectedTimezone = 'UTC';
  }

  return momentDate.tz(selectedTimezone).format(format);
}
